export const formatProviderNames = new Proxy(
  {
    gitslotpark: 'PragmaticNew',
    gr8: 'Ultim8',
    winfinityslots: 'Winfinity Slots',
    winfinitylive: 'Winfinity Live Casino',
  },
  {
    get(target, key) {
      return target?.[key] || key;
    },
  },
);
